import { useAppSelector } from 'flow/hooks/useRedux';

import { Contact } from 'flow/types/Contact';
import { ContactKey, ExtensionKey } from 'flow/types/EntityKeys';

import { TypedMap } from 'flow/types/TypedMap';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';

interface ContactHook {
    contact: TypedMap<Contact>;
    ownContact: TypedMap<Contact>;
    ownContactKey: ContactKey;
    contactKey: ContactKey;
}

const useContact = (extensionKey?: ExtensionKey): ContactHook => {
    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);

    if (!extensionKey) {
        extensionKey = ownExtensionKey;
    }
    const contactKey = useAppSelector((state) =>
        state.extensions.getIn(['extensions', extensionKey, 'contact', 'key']),
    );

    const contact = useAppSelector((state) =>
        state.extensions.getIn(['extensions', extensionKey, 'contact']),
    );

    const ownContact = useAppSelector((state) =>
        state.app.getIn(['extension', 'contact']),
    );

    const ownContactKey = useAppSelector((state) =>
        state.app.getIn(['extension', 'contact', 'key']),
    );

    return { contact, contactKey, ownContact, ownContactKey };
};

export default useContact;
